export default "__VITE_ASSET__f6da63fa__"